import 'aos/dist/aos.css';

import './src/styles/global.css';
